<template>
    <div>
        <div class="card shadow">
            <a id="button"></a>
            <div class="card-header bg-transparent">
                <div>
                    <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> 
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $t('message.manuscritConsultations') }}
                    </h3>
                </div>
            </div>
            <div class="card-body p-0">
                <h3 class="text-center"> {{$t('message.infoConsultation')}}
                </h3>
                <b-form  v-if="show">
                    <b-container class="p-0">
                        <div class="form-group col-md-12">
                            <span class="obligatoire">*</span>
                            <label for="etablissement_id">{{ $t('message.nomEtablissement') }}</label>
                            <autocomplete
                                :search="getEtablisssements"
                                placeholder="Rechercher l'établissement"
                                aria-label="Rechercher l'établissement"
                                :get-result-value="getValueEtablissement"
                                @submit="chooseEtablissement"
                            ></autocomplete>
                            <input type="hidden" name="etablissement_id" id="etablissement_id" v-model="$v.form.etablissement_id.$model" class="form-control" v-validate="'required'" :class="errors.has('etablissement_id') ? 'is-invalid' : ''"/>
                            <small id="emailHelp" class="form-text text-danger" v-if="$v.form.etablissement_id.$error">Rassurez-vous d'avoir sélectionné l'établissement</small> 
                        </div>
                        <b-row class="p-0">
                            <b-col sm="12">
                                <span class="obligatoire">*</span>
                                <b-form-group id="activity-group" :label="$t('message.activity')" label-for="activity">
                                    <multiselect v-model="$v.form.activity_id.$model" :options="missions" :multiple="true" :close-on-select="true" :clear-on-select="false" :preserve-search="true" :placeholder="$t('message.activities')" label="description_fr" track-by="id"></multiselect>
                                    <b-form-invalid-feedback v-if="$v.form.activity_id.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('activity_id')" style="color:red">
                                        {{getErrorsField('activity_id')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="institution-group"
                                        :label="$t('message.institutionConsultation')"
                                        label-for="institution"
                                >
                                    <select id="institution" v-model="$v.form.etablissement_id.$model"
                                            @change="clearErrorField('etablissement_id')"
                                            class="form-control is-invalid retirerBordure"
                                            required
                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in mInstitutions" :key="item.id" :value="item.id">
                                            {{ item.nom }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback class="ml-3" v-if="$v.form.etablissement_id.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('etablissement_id')" style="color:red">
                                    {{getErrorsField('etablissement_id')}}
                                    </span>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="consultationxs-group"
                                        :label="$t('message.typeOfConsultation')"
                                        label-for="consultationxs"
                                >
                                    <select id="consultationxs" v-model="$v.form.name.$model"
                                            @change="clearErrorField('name')"
                                            class="form-control is-invalid retirerBordure"
                                            required
                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in consultations" :key="item" :value="item">
                                            {{ item }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback class="ml-3" v-if="$v.form.name.$error && !checked">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('name')" style="color:red">
                                    {{getErrorsField('name')}}
                                    </span>

                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <b-form-checkbox class="mt-3 mb-3 ml-3" v-model="checked" name="check-button" switch>
                                    {{$t('message.consultationExiste')}} <b>{{ checked ? $t('message.yes') : $t('message.no')}}</b>
                                </b-form-checkbox>
                                <span v-if="checked"  class="obligatoire">*</span>
                                <b-form-group v-if="checked"
                                              id="name-group"
                                              :label="$t('message.consultationName')"
                                              label-for="name"
                                              :aria-placeholder="$t('message.typeOfConsultation')"

                                >
                                    <b-form-input
                                            id="name"
                                            v-model="$v.form.name.$model"
                                            :state="$v.form.name.$dirty ? !(errorshasField('name') || $v.form.name.$error) : null"
                                            required
                                            :disabled="!checked"
                                            @focus="clearErrorField('date_consultation')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.name.checkValidation">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('name')">
                                        {{ getErrorsField('name') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="consultation-group"
                                        :label="$t('message.consultationDate')"
                                        label-for="consultation"
                                        description="">
                                    <b-form-input
                                            id="consultation"
                                            v-model="$v.form.date_consultation.$model"
                                            :state="$v.form.date_consultation.$dirty ? !(errorshasField('date_consultation') || $v.form.date_consultation.$error) : null"
                                            type="date"
                                            required
                                            @focus="clearErrorField('date_consultation')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.date_consultation.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('date_consultation')">
                                        {{ getErrorsField('date_consultation') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="contributors-group"
                                        :label="$t('message.nomPractitioners')"
                                        label-for="contributors"
                                >
                                    <select id="contributors" v-model="$v.form.user_id.$model"
                                            @change="clearErrorField('contributeurs')"
                                            class="form-control is-invalid retirerBordure"
                                            required
                                    >
                                        <option data-placeholder="true"></option>
                                        <option v-for="item in mContributors" :key="item.id" :value="item.id">
                                            {{ item.civilite }} {{ item.nom }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback class="ml-3" v-if="$v.form.user_id.$error && !praticienChecked">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('contributeurs')" style="color:red">
                                    {{getErrorsField('contributeurs')}}
                                    </span>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <b-form-checkbox class="mt-3 mb-3 ml-3" v-model="praticienChecked" name="check-p-button" switch>
                                    {{$t('message.praticienExiste')}} <b>{{ praticienChecked ? $t('message.yes') : $t('message.no')}}</b>
                                </b-form-checkbox>
                                <span v-if="praticienChecked" class="obligatoire">*</span>
                                <b-form-group v-if="praticienChecked"
                                              id="user_id-group"
                                              :label="$t('message.nomPractitioners')"
                                              label-for="user_id"
                                              :aria-placeholder="$t('message.nomPractitioners')"

                                >
                                    <b-form-input
                                            id="name"
                                            v-model="$v.form.user_id.$model"
                                            :state="$v.form.user_id.$dirty ? !(errorshasField('user_id') || $v.form.user_id.$error) : null"
                                            required
                                            :disabled="!praticienChecked"
                                            @focus="clearErrorField('user_id')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.user_id.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('user_id')">
                                        {{ getErrorsField('user_id') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col sm="8">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="upload-group"
                                        :label="$t('message.uploadFile')"
                                        label-for="upload"
                                >
                                    <b-form-file multiple
                                        type="file"
                                        accept=".jpeg, .png, .gif, .pdf, .docx, .jpg, .JPG"
                                        ref="file_input"
                                        id="upload"
                                        v-validate="{required:true, size:4096}"
                                        :state="$v.form.documents.$dirty ? !$v.form.documents.$error : null"
                                        :placeholder="$t('message.uploadFile')">
                                        <template slot="file-name" slot-scope="{ names }">
                                            <b-badge variant="dark">{{ names[0] }}</b-badge>
                                            <b-badge v-if="names.length > 1" variant="dark" class="ml-1">
                                                + {{ names.length - 1 }} More documents
                                            </b-badge>
                                        </template>
                                    </b-form-file>
                                    <span style="color: red" v-if="errorshasField('documents')">
                                        {{ getErrorsField('documents') }}
                                    </span>

                                    <span style="color: red" v-if="maxFileSize.length>0" >{{ maxFileSize }}</span>
                                    <span style="color: red" v-if="fileHasError">
                                    {{ $t('message.requiredField') }}
                                </span>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group
                                        id="u"
                                        label="."
                                        label-for="upload"
                                >
                                    <b-button @click="cleardocuments">{{ $t('message.emptyUpload') }}</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="justify-content-center">
                            <b-button @click="onSubmit" variant="primary" v-if="can">
                                {{ $t('message.save') }}
                            </b-button>
                        </b-row>
                    </b-container>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { required,minLength,helpers } from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import SlimSelect from 'slim-select';
    import moment from 'moment';
    import { mapGetters } from 'vuex';
    import Multiselect from 'vue-multiselect';
    import axios from "axios";
    import AppConfig from "../../../constants/AppConfig";
    import Autocomplete from '@trevoreyre/autocomplete-vue'
    import '@trevoreyre/autocomplete-vue/dist/style.css'

    export default {
        name: "AddManuscrit",
        components: {
            Multiselect,
            Autocomplete
        },
        computed: {
            ...mapGetters([
                "practitioners",
                "controlDoctors",
                "userInstitutions",
                "errors",
                'hasAdminRole',
                'hasMedecinControleRole','hasAssistante',
                'hasPraticienRole',
                "consultationTypes",
            ]),

            can: function () {
                if (this.hasAdminRole) {
                    return true;
                } else {
                    return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
                }
            },

            consultations:function(){
                let cArray = [];
                let nArray = [];
                let self = this;
                _.forEach(self.consultationTypes, function (consultation) {
                    cArray.push(consultation.name);
                })
                return cArray;
            },

            mInstitutions: function () {
                let iArray = [];

                _.forEach(_.orderBy(this.userInstitutions, ['created_at'], ['desc']), function (institution) {
                    let i = {};

                    i.nom = institution.name;
                    i.description = (!_.isNull(institution.description)? institution.description.length > 20 : false) ? institution.description.substr(0, 20) + '...' : institution.description;
                    i.date = moment(institution.created_at).format('DD-MM-YYYY');
                    i.id = institution.id;
                    i.slug = institution.slug;

                    iArray.push(i);
                });

                return iArray;
            },

            mPractitioners: function() {
                let pArray = [];
                    // console.log(this.practitioners);
                _.forEach(_.orderBy(this.practitioners,['created_at'],['desc']), function(practitioner) {
                    let p = {};
                    if((typeof practitioner.user == 'object') && (!_.isNull(practitioner.user)) ){
                        let prenom = practitioner.user.prenom != 'null' && !_.isNull(practitioner.user.prenom) ? practitioner.user.prenom : '';
                        prenom =  prenom.toLowerCase();
                        p.nom =  (practitioner.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                        p.id = practitioner.user.id;
                        p.civilite = practitioner.civilite;
                        if (p.nom.length >0){
                            pArray.push(p);
                        }
                    }

                });

                return pArray;
            },

            mDoctors: function() {
                let dArray = [];
                _.forEach(_.orderBy(this.controlDoctors,['created_at'],['desc']), function(doctor) {
                    let d = {};
                    if((typeof doctor.user == 'object') && (!_.isNull(doctor.user))){
                        let prenom = doctor.user.prenom != null ?  doctor.user.prenom : "";
                        prenom =  prenom.toLowerCase();
                        d.nom =  (doctor.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                        d.id = doctor.user.id;
                        d.civilite = doctor.civilite;

                        if (d.nom.length >0){
                            dArray.push(d);
                        }
                    }

                });

                return dArray;
            },

            mContributors:function () {
                let cArray = [];
                return cArray.concat(this.mDoctors,this.mPractitioners);
                // console.log(this.mDoctors,this.mPractitioners);
            },

            today: function () {
                return moment((new Date())).format('YYYY-MM-DD');
            },
        },
        data(){
            return {
                consultationSelect:Object,
                praticienSelect:Object,
                checked:false,
                praticienChecked:false,
                file_id: this.$route.params.file,
                maxFileSize:'',
                missions: [],
                fileHasError:false,
                form: {
                    activity_id: '',
                    etablissement_id:null,
                    date_consultation: this.today,
                    user_id:JSON.parse(localStorage.getItem('user'))['id'],
                    documents:[],
                    name:'',
                },
                show: true,
            }
        },
        watch:{
            checked:function (newValue, oldValue) {
                this.form.name = '';
                if (newValue == true){
                    this.consultationSelect.disable();
                }else{
                    this.consultationSelect.enable();
                }
            },
            praticienChecked:function (newValue, oldValue) {
                this.form.user_id = '';
                if (newValue == true){
                    this.praticienSelect.disable();
                }else{
                    this.praticienSelect.enable();
                }
            }
        },

        methods: {
            getEtablisssements(input){
                return new Promise(resolve => {
                    if (input.length < 2) {
                    return resolve([])
                    }
                    fetch(AppConfig.apiUrl+'/search/etablissements/'+input, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}})
                    .then(res => res.json())
                    .then(res => {
                        resolve(res.etablissements)
                    }).catch(error => {
                        console.log('error ', error);
                    })
                })
            },
            getValueEtablissement(result) {
                return result.name
            },
            chooseEtablissement(result) {
                this.form.etablissement_id = result.id;
            },
            getGroupeActivites: function () {
                axios
                    .get(AppConfig.apiUrl + "/mission/list")
                    .then((res) => {this.missions = res.data.activites.map((x )=> ({
                        id: x.id,
                        description_fr: x.description_fr
                    }))})
                    .catch((error) => {window.console.log(error)});
            },
            getConsultationTypes() {
                const args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getConsultationTypes', { args : args });
            },

            getDoctors() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getControlDoctors', {args: args});
            },

            getPractitioners() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getPractitioners', {args: args});
            },

            cleardocuments() {
                this.$refs['file_input'].reset()
            },

            getUserInstitutions() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getUserInstitutions', {args: args});
            },

            pathTo(element) {
                if (this.$route.fullPath.includes('#')) {
                    let position = this.$route.fullPath.search('#');
                    return this.$route.fullPath.substr(0, position) + element;
                }
                return this.$route.fullPath + element;
            },


            getErrorsField(field) {
                if (this.errorshasField(field)) {
                    return this.errors[field][0];
                } else {
                    return '';
                }
            },

            errorshasField(field) {
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field) {
                this.$store.dispatch('clearErrorField', {field});

                this.getErrorsField(field);
            },

            onSubmit: function (evt) {
                evt.preventDefault();

                this.$v.form.$touch();

                let files = this.$refs.file_input.files;
                let nomFichier = "";
                let taille = 0;

                if (files != "") {
                    _.forEach(files, function (file, key) {
                        taille += (((file.size) / 1024) / 1024).toFixed(4);
                        if (taille > 5) {
                            nomFichier += key == 0 ? '' : ',' + file.name + ": " + taille + " Mo";
                        }
                    });
                    if (nomFichier.length > 0) {
                        this.maxFileSize = this.$i18n.t('message.maxFileSize') + nomFichier;
                    } else {
                        this.maxFileSize = "";
                    }
                }
                // console.log("taile",taille);
                // console.log("form",this.form);
                // console.log("fichier",files);
                // console.log("this.$ref", this.$refs.file_input.files);
                // console.log("nomfichier",nomFichier);
                // console.log("this.documents",this.form.documents);
                this.fileHasError = (taille == 0 || files == null);

                if (!this.$v.form.$invalid && nomFichier.length == 0 && this.fileHasError == false) {
                    let formData = new FormData();
                    formData.append('dossier_medical_id', this.file_id);
                    formData.append('etablissement_id', this.form.etablissement_id);
                    formData.append('date_consultation', this.form.date_consultation);
                    formData.append('activity_id', this.form.activity_id);
                    formData.append('name', !this.checked ? this.form.name :null);
                    formData.append('user_id', !this.praticienChecked ? this.form.user_id :null);
                    formData.append('consultation_externe', this.checked ? this.form.name :null);
                    formData.append('praticien_externe', this.praticienChecked ? this.form.user_id :null);
                    if (!_.isNull(files)) {
                        for (var i = 0; i < this.$refs.file_input.files.length; i++) {
                            let file = this.$refs.file_input.files[i];
                            formData.append('documents[' + i + ']', file);
                        }
                    }

                    let successMessage = this.$i18n.t('message.manuscritConsultationsCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createManuscrit', {args: formData, errorMessages, successMessage})

                }
            }

        },
        validations: {
            form: {
                activity_id:{
                    required
                },
                etablissement_id: {required},
                date_consultation: {required},
                name:{required},
                user_id:{required},
                documents:{},
                // name:{required},
                // user_id:{required}
            }
        },

        mounted() {
            this.getGroupeActivites();
            // Fetch control doctor list
            this.getDoctors();

            // Fetch practitioner list
            this.getPractitioners();

            // Fetch user institution list
            this.getUserInstitutions();


            this.getConsultationTypes();

            this.$v.form.date_consultation.$model = this.today;

            new SlimSelect({
                select: '#institution',
                placeholder: 'Select institution',
                limit: 1
            });

            var praticien = new SlimSelect({
                select: '#contributors',
                placeholder: 'Select contributors',
                limit: 1
            });

            var consultation =  new SlimSelect({
                select: '#consultationxs',
                placeholder: 'Select consultation',
                limit: 1
            });

            this.consultationSelect = consultation;
            this.praticienSelect = praticien;
        }
    }
</script>

<style scoped>

</style>